import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, integer, pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Lesson } from '../lesson'
import { LessonModule } from './lesson-module'

export const LessonModuleToLesson = pgTable(
  'lesson_module_to_lesson',
  {
    lessonModuleId: uuid()
      .notNull()
      .references(() => LessonModule.id, { onDelete: 'cascade' }),
    lessonId: uuid()
      .notNull()
      .references(() => Lesson.id, { onDelete: 'cascade' }),
    order: integer().notNull(), // Order of lesson within the module
  },
  (table) => [
    primaryKey({ columns: [table.lessonModuleId, table.lessonId] }),
    index('lesson_module_to_lesson_module_idx').on(table.lessonModuleId),
    index('lesson_module_to_lesson_lesson_idx').on(table.lessonId),
    index('lesson_module_to_lesson_order_idx').on(table.order),
  ],
)

export const lessonModuleToLessonRelations = relations(LessonModuleToLesson, ({ one }) => ({
  lessonModule: one(LessonModule, {
    fields: [LessonModuleToLesson.lessonModuleId],
    references: [LessonModule.id],
  }),
  lesson: one(Lesson, {
    fields: [LessonModuleToLesson.lessonId],
    references: [Lesson.id],
  }),
}))

export const InsertLessonModuleToLessonSchema = createInsertSchema(LessonModuleToLesson)
export const UpdateLessonModuleToLessonSchema = createUpdateSchema(LessonModuleToLesson).partial()
export const SelectLessonModuleToLessonSchema = createSelectSchema(LessonModuleToLesson)

export type InsertLessonModuleToLesson = typeof LessonModuleToLesson.$inferInsert
export type UpdateLessonModuleToLesson = z.infer<typeof UpdateLessonModuleToLessonSchema>
export type SelectLessonModuleToLesson = typeof LessonModuleToLesson.$inferSelect
